import React from 'react';
import { CheckIcon } from 'lucide-react';
interface ProgressIndicatorProps {
  currentStep: number;
  totalSteps: number;
}
export const ProgressIndicator = ({
  currentStep,
  totalSteps
}: ProgressIndicatorProps) => {
  return <div className="flex justify-between mb-8" data-id="element-488">
      {Array.from({
      length: totalSteps
    }).map((_, index) => <div key={index} className="flex items-center" data-id="element-489">
          <div className={`w-8 h-8 rounded-full flex items-center justify-center ${currentStep > index + 1 ? 'bg-sky-500 text-white' : currentStep === index + 1 ? 'bg-sky-500 text-white' : 'bg-gray-200 text-gray-500'}`} data-id="element-490">
            {currentStep > index + 1 ? <CheckIcon size={16} data-id="element-491" /> : index + 1}
          </div>
          {index < totalSteps - 1 && <div className={`h-1 w-16 sm:w-24 md:w-32 ${currentStep > index + 1 ? 'bg-sky-500' : 'bg-gray-200'}`} data-id="element-492" />}
        </div>)}
    </div>;
};